<template>
  <div class="dataGridEditRow">
    <div
      class="dataGridEditRow__controls"
      :class="{ _isReactive: isReactive }"
    >
      <div v-if="!isReactive" class="dataGridEditRow__applyActions">
        <b-button :variant="isCreated ? 'primary' : 'success'" @click="saveForm">
          <span v-if="isCreated">Save</span>
          <span v-else>Create</span>
        </b-button>
        <b-button variant="danger" @click="cancel">Cancel</b-button>
      </div>
      <div>
        <b-button @click="editFormData" variant="primary">Edit Form</b-button>
      </div>
    </div>
    <DataGridFormBuilder
      v-if="formData"
      type="gui"
      :form="formData"
      :options="options"
      :gridId="gridId"
      :rowKey="rowKey"
      ref="form"
      @rowDataChanged="save"
    />
    <div class="dataGridEditRow__comments">
      <row-comments :rowKey="rowKey" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import extOpts from './extension-options'
import { cloneDeep } from 'lodash'
// components
import DataGridFormBuilder from '@/components/DataGrid/FormBuilder'
import RowComments from '@/components/DataGrid/FormBuilder/gui/ui/comments/RowComments'
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  props: ['gridId', 'rowKey', 'view'],
  components: {
    DataGridFormBuilder,
    RowComments,
  },
  data() {
    return {
      formData: null,
      unwatch: null,
      options: extOpts,
      saveTimeoutId: null,
    }
  },
  computed: {
    ...mapState(['dataGrid_options', 'currentDash']),
    title() {
      if (!this.exists()) return null

      const gridTitle = this.dataGrid_options[this.gridId].title

      return `Edit "${gridTitle}" `
    },
    isReactive() {
      if (typeof this.dataGrid_options[this.gridId].isReactive === 'undefined') return true
      return this.dataGrid_options[this.gridId].isReactive
    },
    isCreated() {
      return $dataGrid(this.gridId)[this.rowKey]._created
    },
  },
  methods: {
    exists() {
      if (!this.gridId || !this.dataGrid_options) return false
      if (!this.dataGrid_options[this.gridId]) return false
      return true
    },
    getFormData() {
      if (!this.exists()) return null

      try {
        return JSON.parse(
          this.dataGrid_options[this.gridId].rowEditorFieldsForm
        )
      } catch (err) {
        console.error(err)
        return null
      }
    },
    updateForm() {
      this.formData = this.getFormData()

      this.$nextTick(() => {
        this.setVals()
      })
    },
    save(cellKey, value) {
      if (!this.$refs.form) return

      const data = {
        options: this.dataGrid_options[this.gridId],
        rowKey: this.rowKey,
        cellKey,
        value,
      }

      db.dataGrid.data.saveCellVal(data)
    },
    saveForm() {
      if (!this.$refs.form.validate()) return

      const emitCreated = $dataGrid(this.gridId)[this.rowKey]._created ? false : true

      db.dataGrid.data.saveRowData(
        this.gridId,
        this.rowKey,
        Object.assign(
          { _created: true },
          this.$refs.form.rowData
        )
      ).then(() => {
        if (emitCreated)
          eventBus.$emit(`simpleWorkflow-rowCreated-${this.gridId}`, $dataGrid(this.gridId)[this.rowKey])
        else
          eventBus.$emit(`simpleWorkflow-rowUpdated-${this.gridId}`, $dataGrid(this.gridId)[this.rowKey])
      })
    },
    cancel() {
      const currentQuery = cloneDeep(this.$route.query)
      delete currentQuery.dgEditMode
      delete currentQuery.gridId
      delete currentQuery.rowKey

      this.$router.push({
        path: '/dashboard/' + this.currentDash,
        query: currentQuery,
      })
    },
    setVals() {
      this.rowData = _.cloneDeep($dataGrid(this.gridId)[this.rowKey])

      const formData = {}

      for (let section of this.formData.sections) {
        formData[section.name] = {}

        for (let row of section.rows) {
          for (let control of row.controls) {
            if (!control.propName) continue
            if (!this.rowData[control.propName]) continue
            formData[section.name][control.name] = this.rowData[
              control.propName
            ]
          }
        }
      }

      this.$refs.form.setValue(formData)
    },
    editFormData() {
      eventBus.$emit(
        'showDataGridEditFormDataModal',
        this.gridId,
        this.rowKey,
        this.view
      )
    },
  },
  created() {
    this.formData = this.getFormData()

    eventBus.$on(`dgForm-${this.gridId}-updated`, this.updateForm)
  },
  mounted() {
    this.setVals()
  },
  beforeDestroy() {
    eventBus.$off(`dgForm-${this.gridId}-updated`, this.updateForm)
  }
}
</script>

<style lang="scss">
.dataGridEditRow {
  &__controls {
    display: flex;
    justify-content: space-between;
    padding: 10px 30px;
    &._isReactive {
      justify-content: flex-end;
    }
  }
  &__comments {
    padding: 0 30px 20px 30px;
  }
}
</style>
